import React, { useEffect, useRef } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import { FadeInWrapper } from '../fade-in-wrapper.tsx'
import { VerifyCodeField } from '../verify-code-field'
import { useResendCodeMutation } from '../../services'
import { Amount, Text } from '../table-cell-renderers'
import { formatMoney } from '../../utils.ts'

import { RefundFormState } from './refund-button.types.ts'
import { useUser } from '@/stores/slices/user-slice.ts'

export const ConfirmRefundStage = ({ resendCodeEndpoint }: { resendCodeEndpoint: string }): React.ReactElement => {
  const requestedCode = useRef(false)
  const user = useUser()
  const { getValues } = useFormContext<RefundFormState>()
  const formValues = getValues()

  const { mutate } = useResendCodeMutation(user?.login ?? '', resendCodeEndpoint)

  useEffect(() => {
    if (!requestedCode.current) {
      mutate()
      requestedCode.current = true
    }
  }, [])

  return (
    <FadeInWrapper>
      <Box
        sx={{
          p: 3,
          mb: 3,
          borderLeft: '4px solid',
          borderRadius: 1,
          borderColor: 'primary.main',
          backgroundColor: 'background.paper',
        }}
      >
        <Typography variant="h5" fontWeight="500" mb={3.5}>
          Данные возврата
        </Typography>
        <Stack direction="row" gap={4}>
          <Box>
            <Typography variant="body2" fontWeight="500">
              Сумма:
            </Typography>
            <Amount value={formValues.reverseSum} />
          </Box>
          <Box>
            <Typography variant="body2" fontWeight="500">
              Назначение:
            </Typography>
            <Text value={formValues?.purpose} />
          </Box>
          {formValues?.email && (
            <Box>
              <Typography variant="body2" fontWeight="500">
                Email клиента:
              </Typography>
              <Text value={formValues.email} />
            </Box>
          )}
          {formValues?.positions && (
            <Box>
              <Typography variant="body2" fontWeight="500">
                Позиции:
              </Typography>
              {formValues.positions.map(({ text, quantity, price, unitOfMeasurement }) => (
                <React.Fragment key={text}>
                  <Text value={`${[text, quantity, unitOfMeasurement, 'x', formatMoney(price)].join(' ')}`} />
                </React.Fragment>
              ))}
            </Box>
          )}
        </Stack>
      </Box>
      <Typography variant="body1" mb={1}>
        Вам был отправлен одноразовый код-подтверждение
      </Typography>
      <VerifyCodeField login={user?.login ?? ''} apiUrl={resendCodeEndpoint} name="emailCode" />
    </FadeInWrapper>
  )
}
